//both client or server
import { myPublicEnvs } from "../env/publicEnv";
export const firebaseConfig = {
    apiKey: myPublicEnvs.NEXT_PUBLIC_FIREBASE_API_KEY!,
    authDomain: myPublicEnvs.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
    projectId: myPublicEnvs.NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
    storageBucket: myPublicEnvs.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    appId: myPublicEnvs.NEXT_PUBLIC_FIREBASE_APP_ID,
    //   measurementId: myPublicEnvs.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID, // optional
} as const;

export const useEmulators =
    process.env.NEXT_PUBLIC_USE_FIREBASE_EMULATORS === "true";

export function assertClientEnv() {
    for (const [k, v] of Object.entries(firebaseConfig)) {
        if (v == null || v === "") {
            throw new Error(`Missing required env: ${k}`);
        }
    }
}
